export default __webpack_public_path__ + "static/collaborator-bec2b85ecbbc73d4b9404db66733044b.png";